import { useEffect, useMemo, useRef } from "react"

import { ConfigQuery, ExtraServicesForUserResponse, fetchExtraServicesForUser } from "../../../createOrderApi"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { DeliveryFulfillmentType } from "../../form/formTypes"
import { ExtraServicesDeliveryAccordion } from "./ExtraServicesDeliveryAccordion"

const transformData = (data: ExtraServicesForUserResponse) => {
    return data.extraServices || []
}

type ExtraServicesForDeliveryProps = Readonly<{
    userId: number
    merchantId: number
    deliveryType: DeliveryFulfillmentType
    deliveryDate: string
    deliveryTime: string | null
    deliveryIndex: number
    onVisibilityChange: (visible: boolean) => void
}>

export function ExtraServicesForDelivery({
    userId,
    merchantId,
    deliveryType,
    deliveryDate,
    deliveryTime,
    deliveryIndex,
    onVisibilityChange,
}: ExtraServicesForDeliveryProps) {
    const deliveryDateTime = useMemo(() => {
        if (!deliveryDate || !deliveryTime) return undefined
        return `${deliveryDate}T${deliveryTime}`
    }, [deliveryDate, deliveryTime])

    const { data: services = [], isFetched } = useApiQuery(fetchExtraServicesForUser, {
        queryName: ConfigQuery.EXTRA_SERVICES_FOR_USER,
        dependencies: {
            userId,
            merchantId,
            deliveryType,
            deliveryTime: deliveryDateTime,
        },
        select: transformData,
        enabled: !!userId && !!merchantId && !!deliveryDateTime,
    })

    const isVisible = isFetched && services.length > 0

    const onVisibilityChangeRef = useRef(onVisibilityChange)
    onVisibilityChangeRef.current = onVisibilityChange

    useEffect(() => {
        onVisibilityChangeRef.current(isVisible)
        return () => onVisibilityChangeRef.current(false)
    }, [isVisible])

    if (!isVisible) return null

    return (
        <ExtraServicesDeliveryAccordion
            services={services}
            deliveryType={deliveryType}
            deliveryTime={deliveryTime!}
            deliveryIndex={deliveryIndex}

        />
    )
}
